"use strict";
/**
 * These whitelists are intended to be used with the applyWhitelist function in ahm-logic, which accepts an object and
 * ensures that the resulting object only has the whitelisted properties on it.
 */
const PRICE_QUERY = [
    'ageBracket',
    'ambulanceSurchargeExempted',
    'clientYouthDiscountAge',
    'date',
    'fund',
    'incomeTier',
    'members[].certifiedAge',
    'members[].continuous',
    'members[].dob',
    'members[].relationship',
    'payment.frequency',
    'payment.method',
    'payment.starts',
    'productId',
    'rateCode',
    'rebate',
    'reload',
    'scale',
    'spouseYouthDiscountAge',
    'starts',
    'state',
];
module.exports = {
    PRICE_QUERY,
};
